export default {
  groups: [],
  newGroup: {
    slug: ''
  }
}
